import { api } from '@app/config/axios';

export async function logoutService() {
  await api.post('/auth/logout');
}
